import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { Event } from './event.model';
import { EventService } from './event.service';

@Injectable()
export class EventPopupService {
    private isOpen = false;

    private defaultStatus: any = 'DRAFT';
    private defaultBeginning: Date;
    private defaultEnding: Date;
    private defaultMinParticipants = 1;
    private defaultMaxParticipants = 100;
    private defaultReminderPolicy = 48;
    private defaultVideoConferenceValue = false;
    private defaultAcceptOnlinePayments = false; // until we have created the online payments for events
    private defaultIsFree = false;
    private defaultHighlighted = false;

    constructor(
        private modalService: NgbModal,
        private eventService: EventService,
        private router: Router
    ) { }

    open(component: Component, id?: number | any  | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.eventService.find(id).subscribe(event => {
                this.eventModalRef(component, event);
            });
        } else {
            let event: Event = new Event();
            event.begining = this.defaultBeginning;
            event.ending = this.defaultEnding;
            event.minParticipants = this.defaultMinParticipants;
            event.maxParticipants = this.defaultMaxParticipants;
            event.reminderPolicy = this.defaultReminderPolicy;
            event.status = this.defaultStatus;
            event.videoConference = this.defaultVideoConferenceValue;
            event.status = this.defaultStatus;
            event.acceptOnlinePayments = this.defaultAcceptOnlinePayments;
            event.free = this.defaultIsFree;
            event.highlighted = this.defaultHighlighted;
            event.bookAndPayLaterEnabled = false;
            setTimeout(() => {
                // the setTimeout is needed to avoid ExpressionChangedAfterItHasBeenCheckedError error in dev mode
                return this.eventModalRef(component, event);
            });
        }
    }

    eventModalRef(component: Component, event: Event): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.event = event;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/event/event-popup.service.ts